(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["osz-kitchen-set"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('osz-kitchen-set')) {
  class OszKitchenSet extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.rows = Array.from(this.querySelectorAll('[data-item]'));
      this.button = this.querySelector('button[type="submit"]');
      this.totalNode = this.querySelector('[data-total]');
      this.countNode = this.querySelector('[data-count]');
      this.notice = this.querySelector('[data-selection-notice]');
      this.result = this.querySelector('[data-result]');
      try {
        this.money = new Intl.NumberFormat(this.dataset.locale || 'en-NZ', {
          style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code'
        });
      } catch (error) {
        console.warn('OSZ kitchen currency unavailable:', error.name);
        return;
      }
      if (!this.boundInput) this.boundInput = () => this.onInput();
      if (!this.boundSubmit) this.boundSubmit = (event) => this.submitSelection(event);
      if (!this.boundBusy) this.boundBusy = () => this.update();
      this.form.addEventListener('input', this.boundInput);
      this.form.addEventListener('change', this.boundInput);
      this.form.addEventListener('submit', this.boundSubmit);
      document.addEventListener('osz:cart-busy', this.boundBusy);
      this.querySelector('[data-summary]').hidden = false;
      this.update();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('input', this.boundInput);
      this.form?.removeEventListener('change', this.boundInput);
      this.form?.removeEventListener('submit', this.boundSubmit);
      document.removeEventListener('osz:cart-busy', this.boundBusy);
    }

    selection() {
      const items = [];
      const invalid = [];
      const seen = new Set();
      let cents = 0;
      let count = 0;
      for (const row of this.rows) {
        if (row.dataset.eligible !== 'true' || !row.querySelector('[data-select]').checked) continue;
        const field = row.querySelector('[data-quantity]');
        const quantity = Number(field.value);
        const price = Number(row.dataset.price);
        const id = row.dataset.variant;
        const max = field.max === '' ? Infinity : Number(field.max);
        if (!Number.isSafeInteger(quantity) || quantity < 1 || quantity > max ||
            !Number.isSafeInteger(price) || price < 0 || !/^\d+$/.test(id) || seen.has(id)) {
          invalid.push(row);
          continue;
        }
        seen.add(id);
        items.push({ id, quantity });
        cents += price * quantity;
        count += quantity;
      }
      return { items, cents, count, invalid, valid: invalid.length === 0 && Number.isSafeInteger(cents) && Number.isSafeInteger(count) };
    }

    update() {
      const selection = this.selection();
      const busy = document.documentElement.dataset.oszCartPending === 'true';
      const blocked = busy || this.locked;
      for (const row of this.rows) {
        if (row.dataset.eligible !== 'true') continue;
        const checkbox = row.querySelector('[data-select]');
        const quantity = row.querySelector('[data-quantity]');
        checkbox.disabled = Boolean(blocked);
        quantity.disabled = Boolean(blocked || !checkbox.checked);
        quantity.setAttribute('aria-invalid', String(selection.invalid.includes(row)));
      }
      this.totalNode.textContent = selection.valid ? this.money.format(selection.cents / 100) : '—';
      this.countNode.textContent = selection.valid ? String(selection.count) : '—';
      this.notice.textContent = !selection.valid ? this.dataset.invalid : (selection.items.length ? '' : this.dataset.empty);
      this.button.disabled = Boolean(blocked || !selection.valid || !selection.items.length);
      this.button.textContent = this.pending ? this.dataset.adding : (this.locked ? this.dataset.check : (this.added ? this.dataset.again : this.dataset.add));
      return selection;
    }

    onInput() {
      if (this.pending || this.locked) return;
      this.added = false;
      this.showMessage('');
      this.update();
    }

    showMessage(text, error = false) {
      this.result.textContent = text;
      this.result.dataset.error = String(error);
      this.result.setAttribute('role', error ? 'alert' : 'status');
      this.result.setAttribute('aria-live', error ? 'assertive' : 'polite');
    }

    setBusy(value) {
      this.pending = value;
      document.documentElement.dataset.oszCartPending = String(value);
      this.form.setAttribute('aria-busy', String(value));
      document.dispatchEvent(new CustomEvent('osz:cart-busy'));
      this.update();
    }

    async request(url, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        return { ok: response.ok, body: await response.json() };
      } finally {
        clearTimeout(timer);
      }
    }

    clearStaleCount() {
      document.querySelectorAll('.cart-link__bubble').forEach((node) => node.classList.remove('cart-link__bubble--visible'));
      document.querySelectorAll('[data-osz-count-group]').forEach((node) => { node.hidden = true; });
    }

    async refreshCount() {
      const response = await this.request(this.dataset.cartUrl + '.js');
      if (!response.ok || !Number.isInteger(response.body.item_count)) throw new Error('Cart count unavailable');
      const count = response.body.item_count;
      document.querySelectorAll('.cart-link__bubble-num, [data-osz-cart-count]').forEach((node) => { node.textContent = String(count); });
      document.querySelectorAll('.cart-link__bubble').forEach((node) => node.classList.toggle('cart-link__bubble--visible', count > 0));
      document.querySelectorAll('[data-osz-count-group]').forEach((node) => { node.hidden = false; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response.body } }));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }

    async submitSelection(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.pending || this.locked || document.documentElement.dataset.oszCartPending === 'true') return;
      const selection = this.update();
      if (!selection.valid || !selection.items.length) return;
      this.added = false;
      this.showMessage('');
      this.setBusy(true);
      try {
        const response = await this.request(this.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: selection.items })
        });
        if (!response.ok || response.body.status >= 400) {
          this.locked = true;
          const description = typeof response.body.description === 'string' ? response.body.description : '';
          this.showMessage((description ? description + ' ' : '') + this.dataset.error, true);
        } else {
          const confirmed = Array.isArray(response.body.items) && selection.items.every((requested) =>
            response.body.items.some((item) => String(item.id) === requested.id && item.quantity >= requested.quantity));
          if (!confirmed) throw new Error('Unconfirmed group add');
          this.added = true;
          this.showMessage(this.dataset.added);
        }
        try {
          await this.refreshCount();
        } catch (error) {
          this.clearStaleCount();
          if (this.added) this.showMessage(this.dataset.countError);
          console.warn('OSZ kitchen cart refresh failed:', error.name);
        }
      } catch (error) {
        this.locked = true;
        this.clearStaleCount();
        this.showMessage(this.dataset.uncertain, true);
        console.warn('OSZ kitchen add could not be confirmed:', error.name);
      } finally {
        this.setBusy(false);
      }
    }
  }
  customElements.define('osz-kitchen-set', OszKitchenSet);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osz-product-picks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('osz-product-picks')) {
  class OszProductPicks extends HTMLElement {
    connectedCallback() {
      if (!this.boundSubmit) this.boundSubmit = this.submitProduct.bind(this);
      this.addEventListener('submit', this.boundSubmit);
      if (!this.boundBusy) this.boundBusy = () => this.syncBusy();
      document.addEventListener('osz:cart-busy', this.boundBusy);
      this.syncBusy();
    }

    disconnectedCallback() {
      this.removeEventListener('submit', this.boundSubmit);
      document.removeEventListener('osz:cart-busy', this.boundBusy);
    }

    message(form, text, error = false) {
      const card = form.closest('.osz-pick');
      const message = card.querySelector('.osz-pick__message');
      message.textContent = text;
      message.dataset.error = String(error);
      message.setAttribute('role', error ? 'alert' : 'status');
      message.setAttribute('aria-live', error ? 'assertive' : 'polite');
      card.querySelector('.osz-pick__view-cart').hidden = false;
    }

    setBusy(value) {
      this.pending = value;
      document.documentElement.dataset.oszCartPending = String(value);
      document.dispatchEvent(new CustomEvent('osz:cart-busy'));
      this.syncBusy();
    }

    syncBusy() {
      const value = document.documentElement.dataset.oszCartPending === 'true';
      this.querySelectorAll('.osz-pick__form').forEach((form) => {
        form.querySelector('button[type="submit"]').disabled = value || form.dataset.locked === 'true';
      });
    }

    async request(url, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
        const body = await response.json();
        return { ok: response.ok, body };
      } finally {
        clearTimeout(timer);
      }
    }

    async refreshCount() {
      const response = await this.request(this.dataset.cartUrl + '.js');
      if (!response.ok || !Number.isInteger(response.body.item_count)) throw new Error('Cart count unavailable');
      const count = response.body.item_count;
      document.querySelectorAll('.cart-link__bubble-num, [data-osz-cart-count]').forEach((node) => { node.textContent = String(count); });
      document.querySelectorAll('.cart-link__bubble').forEach((node) => { node.classList.toggle('cart-link__bubble--visible', count > 0); });
      document.querySelectorAll('[data-osz-count-group]').forEach((node) => { node.hidden = false; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response.body } }));
    }

    clearStaleCount() {
      document.querySelectorAll('.cart-link__bubble').forEach((node) => { node.classList.remove('cart-link__bubble--visible'); });
      document.querySelectorAll('[data-osz-count-group]').forEach((node) => { node.hidden = true; });
    }

    async submitProduct(event) {
      const form = event.target;
      if (!form.matches('.osz-pick__form')) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.pending || form.dataset.locked === 'true' || document.documentElement.dataset.oszCartPending === 'true') return;
      const button = form.querySelector('button[type="submit"]');
      const id = form.elements.namedItem('id').value;
      if (!/^\d+$/.test(id)) {
        this.message(form, this.dataset.invalid, true);
        return;
      }
      this.setBusy(true);
      form.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.adding;
      let added = false;
      try {
        const response = await this.request(form.getAttribute('action').split('?')[0] + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] })
        });
        if (!response.ok || response.body.status >= 400) {
          form.dataset.locked = 'true';
          const description = typeof response.body.description === 'string' ? response.body.description : this.dataset.error;
          this.message(form, description + ' ' + this.dataset.check, true);
        } else {
          if (!Array.isArray(response.body.items) || !response.body.items.some((item) => String(item.id) === id && item.quantity > 0)) {
            throw new Error('Unconfirmed add response');
          }
          added = true;
          this.message(form, this.dataset.added);
        }
        try {
          await this.refreshCount();
          document.dispatchEvent(new CustomEvent('cart:build'));
        } catch (error) {
          this.clearStaleCount();
          if (added) this.message(form, this.dataset.countError);
          console.warn('OSZ cart count refresh failed:', error.name);
        }
      } catch (error) {
        form.dataset.locked = 'true';
        this.clearStaleCount();
        this.message(form, this.dataset.uncertain, true);
        console.warn('OSZ cart add could not be confirmed:', error.name);
      } finally {
        form.setAttribute('aria-busy', 'false');
        button.textContent = form.dataset.locked === 'true' ? this.dataset.check : (added ? this.dataset.addAnother : this.dataset.add);
        this.setBusy(false);
      }
    }
  }
  customElements.define('osz-product-picks', OszProductPicks);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osz-social-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('osz-hero-carousel')) {
  customElements.define('osz-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.controls = this.querySelector('[data-controls]');
      if (this.slides.length < 2 || !this.controls) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.timer = null;
      this.hovered = false;
      this.inView = !('IntersectionObserver' in window);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches || this.dataset.editor === 'true';
      this.toggle = this.querySelector('[data-toggle]');
      this.counter = this.querySelector('[data-counter]');
      this.announcement = this.querySelector('[data-announcement]');
      this.controls.hidden = false;
      this.querySelector('[data-previous]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.toggle.addEventListener('pointerdown', () => { this.toggleIntent = !this.paused; }, options);
      this.toggle.addEventListener('click', () => {
        this.paused = this.toggleIntent ?? !this.paused;
        this.toggleIntent = null;
        this.sync();
      }, options);
      this.addEventListener('focusin', () => this.stop(), options);
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.sync();
      }, options);
      this.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.sync();
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, options);
      this.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' || !event.target.closest('[data-swipe-surface]')) return;
        this.startPoint = { x: event.clientX, y: event.clientY, id: event.pointerId };
        this.stop();
      }, options);
      this.addEventListener('pointerup', (event) => {
        const start = this.startPoint;
        this.startPoint = null;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.move(dx < 0 ? 1 : -1);
      }, options);
      this.addEventListener('pointercancel', () => { this.startPoint = null; }, options);
      this.addEventListener('dragstart', (event) => event.preventDefault(), options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.sync();
      }, options);
      document.addEventListener('shopify:block:select', (event) => {
        const target = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
        if (target >= 0) {
          this.stop();
          this.show(target, true);
        }
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.25);
          this.sync();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this);
      }
      this.show(0, false);
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
    stop() {
      this.paused = true;
      this.sync();
    }
    move(delta) {
      this.stop();
      this.show((this.index + delta + this.slides.length) % this.slides.length, true);
    }
    show(index, announce) {
      this.index = index;
      this.slides.forEach((slide, position) => {
        const active = position === index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
      });
      this.counter.textContent = (index + 1) + ' / ' + this.slides.length;
      if (announce) this.announcement.textContent = this.dataset.slideLabel + ' ' + this.counter.textContent + ': ' + this.slides[index].querySelector('h2').textContent;
    }
    sync() {
      clearTimeout(this.timer);
      this.timer = null;
      this.toggle.hidden = this.motion.matches;
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      if (this.paused || this.motion.matches || this.hovered || document.hidden || !this.inView) return;
      this.timer = setTimeout(() => {
        this.show((this.index + 1) % this.slides.length, false);
        this.sync();
      }, 7000);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
